export interface ISizeDefinition {
    minHeightViewport?: number
    minWidthViewport?: number
    jsonEncodedSizes?: string
    placementId?: number

    //Generated based in the JsonEncodedSizes
    sizes?: any[]
}

export class SizeDefinition implements ISizeDefinition {
    
    id?: number;
    dateCreated?: string;
    minHeightViewport: number;
    minWidthViewport: number;
    jsonEncodedSizes: string;
    placementId: number;
    sizes?: any[];

    constructor()
    constructor(obj: SizeDefinition)
    constructor(obj?: ISizeDefinition) {
        this.minHeightViewport = obj && obj.minHeightViewport || undefined;
        this.minWidthViewport = obj && obj.minWidthViewport || undefined;
        this.jsonEncodedSizes = obj && obj.jsonEncodedSizes || undefined;
        this.placementId = obj && obj.placementId || undefined;
        this.sizes = obj && obj.sizes || [];
    }
}

export class Size {
    width: number
    height: number

    constructor(w: number, h: number) {
        this.width = w;
        this.height = h;
    }
}
